import { Pipe, PipeTransform } from '@angular/core';
import {ProfileModel} from '../models/profile.model';
import { ProfileResultModel } from '../models/profile-result.model';

@Pipe({
    name: 'profileFilterPipe',
})
export class ProfileFilterPipe implements PipeTransform {

    transform(profiles: Array<ProfileResultModel>, searchStr: string): any {
        searchStr = searchStr.toString().toLowerCase();
        const filteredProfiles: Array<ProfileResultModel> = [];
        if (searchStr.length === 0) {
            return profiles;
        }
        console.log('profiles: ', profiles);
        for (const profile of profiles){
            if (
                profile.id.toString().indexOf(searchStr) !== -1 ||
                profile.name.toString().toLowerCase().indexOf(searchStr) !== -1
            ) {
                filteredProfiles.push(profile);
            }
        }
        return filteredProfiles;
    }

}